

































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import {
  IMenu,
  MenuType,
  EditActionEvent,
  EditActionBehavior,
} from '@/types/type';

@Component
export default class EditableListItem extends Vue {
  @Prop()
  private editable!: boolean;
  @Prop()
  private menu!: IMenu;

  @Emit('edit-item-action')
  private action(target: keyof EditActionBehavior): EditActionEvent {
    return { menu: this.menu, action: target, index: -1, change: true };
  }
}
